import classnames from 'classnames';
import React from 'react';
import Wix, { openModal, isPremium } from '../../commons/services/Wix';
import request from '../../commons/services/request';
import createStylesContainer
  from '../../commons/components/createStylesContainer';
import SelectErrorMessage from '../../commons/components/SelectErrorMessage';
import { getNormalizedBadgeId, badgesById } from '../../commons/badges/index';
import {
  AUTH_ERROR,
  UNEXPECTED_ERROR
} from '../../commons/services/errorCodes';
import './Widget.css';

function createWidgetContainer(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.onSettingsUpdate = this.onSettingsUpdate.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onEditModeChange = this.onEditModeChange.bind(this);
      this.onSitePublished = this.onSitePublished.bind(this);

      this.state = {
        data: null,
        viewMode: Wix.Utils.getViewMode(),
        errorCode: null
      };
    }

    onEditModeChange() {
      this.setState(() => {
        return {
          viewMode: Wix.Utils.getViewMode()
        };
      });
    }

    onSettingsUpdate(data) {
      this.setState(() => ({
        data
      }));
    }

    onSitePublished() {
      request.post('/api/settings/publish');
    }

    onClick(ev) {
      const { modalEnabled } = this.props.styles;
      const svgEl = this.widgetEl.querySelector('svg');

      if (
        !modalEnabled ||
        !isPremium() ||
        !svgEl ||
        (svgEl.contains && !svgEl.contains(ev.target)) ||
        svgEl === ev.target
      ) {
        return;
      }

      openModal();
    }

    componentDidMount() {
      Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, this.onSettingsUpdate);
      Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, this.onEditModeChange);
      Wix.addEventListener(Wix.Events.SITE_PUBLISHED, this.onSitePublished);

      const type = this.state.viewMode === 'site' ? 'public' : 'draft';

      request.get(`/api/settings/${type}`).then(
        ({ data }) => {
          this.setState(() => ({
            data
          }));
        },
        err => {
          this.setState(() => ({
            errorCode: err.response.status === 403
              ? AUTH_ERROR
              : UNEXPECTED_ERROR
          }));
        }
      );
    }

    componentWillUnmount() {
      Wix.removeEventListener(
        Wix.Events.SETTINGS_UPDATED,
        this.onSettingsUpdate
      );
      Wix.removeEventListener(
        Wix.Events.EDIT_MODE_CHANGE,
        this.onEditModeChange
      );
      Wix.removeEventListener(Wix.Events.SITE_PUBLISHED, this.onSitePublished);
    }

    render() {
      const { errorCode, hide } = this.state;

      if (hide) {
        return null;
      }

      if (errorCode) {
        return <SelectErrorMessage code={errorCode} />;
      }

      return (
        <div
          className="Widget"
          ref={el => this.widgetEl = el}
          onClick={this.onClick}
        >
          <WrappedComponent {...this.state} {...this.props} />
        </div>
      );
    }
  };
}

function Widget({ data, styles }) {
  if (!data || !data.selectedBadge || !styles) {
    return null;
  }

  const selectedBadge = getNormalizedBadgeId(data.selectedBadge);

  const {
    BadgeComponent,
    animated,
    supportsNoSubline,
    ...otherBadgeSettings
  } = badgesById[data.hoverBadge || selectedBadge];

  return (
    <div>
      <BadgeComponent
        {...otherBadgeSettings}
        className={classnames({
          'Badge--clickable': isPremium() && styles.modalEnabled,
          'Badge--overwriteColors': !data.badgeDefaultColors,
          'Badge--animated': animated && styles.animateEnabled
        })}
        disableSubline={supportsNoSubline && styles.noSublineEnabled}
        enableChromeRenderingHack
        data={data}
        styles={styles}
      />
    </div>
  );
}

export default createStylesContainer(createWidgetContainer(Widget));



// WEBPACK FOOTER //
// ./src/apps/widget/Widget.jsx